import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal } from "./Reveal";

const PROGRAMS = [
  { title: "Group Fitness", desc: "Fun, challenging group workouts with built-in accountability.", bestFor: "Lovers of shared energy" },
  { title: "One-on-One Coaching", desc: "Fully personalized coaching around your body, goals and lifestyle.", bestFor: "Focused attention" },
  { title: "Nutrition Coaching", desc: "Practical, sustainable eating habits — no extremes, no guilt.", bestFor: "Diet-fatigued" },
  { title: "Fitness + Nutrition", desc: "Training, nutrition, accountability and habits in one package.", bestFor: "A full reset" },
];

const ProgramsCompact = () => {
  const navigate = useNavigate();
  return (
    <section id="programs" className="py-16 sm:py-20 bg-mint" data-testid="programs-compact-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
            <div>
              <p className="text-xs tracking-[0.25em] uppercase font-bold text-brand-dark mb-3 flex items-center gap-3">
                <span className="text-charcoal/40">03</span>
                <span className="h-px w-10 bg-charcoal/30" aria-hidden="true" />
                Programs
              </p>
              <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-charcoal">
                Find the Right Fit for You
              </h2>
            </div>
            <p className="max-w-xs text-sm text-charcoal/60 leading-relaxed sm:text-right">
              Not sure where to start? Reach out — we'll figure it out together.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {PROGRAMS.map((p, i) => (
            <Reveal key={p.title} delay={0.06 * i} y={24}>
              <article
                className="group h-full flex flex-col rounded-2xl bg-charcoal border border-sand/10 p-6 hover:border-brand/70 hover:-translate-y-0.5 transition-[border-color,transform] duration-300"
                data-testid={`program-compact-card-${i}`}
              >
                <h3 className="font-display text-lg font-bold tracking-tight text-sand">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-sand/60 leading-relaxed flex-1">{p.desc}</p>
                <p className="mt-3 text-[11px] uppercase tracking-[0.15em] font-bold text-sand/40">
                  Best for: <span className="text-sand/75">{p.bestFor}</span>
                </p>
                <button
                  onClick={() => navigate("/contact")}
                  data-testid={`program-compact-fit-btn-${i}`}
                  className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-sand hover:text-brand transition-colors duration-200 self-start"
                >
                  FIND YOUR FIT
                  <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                </button>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProgramsCompact;
